// Third-party
import React, { ReactElement } from 'react';
import classNames from 'classnames';

// Components
import DefaultModal from './DefaultModal';

// Utils
import { formatMessage } from '../../../utils/i18n';
import ModalSize from '@/types/modal-size';

type Props = {
  title: ReactElement | string;
  body: ReactElement | string;
  show: boolean;
  onCancel: () => void;
  className?: string;
  actionLabel?: string;
  size?: ModalSize;
  backdropClassName?: string;
  modalClassName?: string;
  isV2?: boolean;
};

const GenericTextModal = (props: Props) => {
  const { title = '', body = '', show = false, onCancel = () => {}, className, actionLabel, size, backdropClassName, modalClassName, isV2, ...rest } = props;

  return (
    <DefaultModal
      className={classNames('generic-text-modal', className)}
      title={title}
      body={body}
      show={show}
      onCancel={onCancel}
      hidePrimaryButton
      hideCancelButton
      secondaryActionLabel={formatMessage(`${actionLabel || 'Common.Close'}`)}
      onSecondaryAction={onCancel}
      size={size}
      backdropClassName={backdropClassName}
      modalClassName={modalClassName}
      isV2={isV2}
      {...rest}
    />
  );
};

export default GenericTextModal;
